import React from 'react'

export default function Contact() {
    return (
        <div className="content contact container">
            <h1>Contact</h1>
            <div className="row">
                <div className="col text-center"><a href="https://www.instagram.com/ja_creati0n/" target="blank"><img src="https://img.icons8.com/cute-clipart/64/000000/instagram-new.png" alt="insta"/></a></div>
                <div className="col text-center"><a href="https://www.facebook.com/jacreati0n" target="blank"><img src="https://img.icons8.com/cute-clipart/64/000000/facebook-new.png" alt="fb"/></a></div>
                <div className="col text-center"><a href="mailto:createionjadev@gmail.com"><img src="https://img.icons8.com/cute-clipart/64/000000/download-mail.png" alt="gmail"/></a></div>
            </div>
            <div className="row">
                <div className="col text-center"><a href="tel:8157929074"><img src="https://img.icons8.com/cute-clipart/64/000000/phone.png" alt="phone"/></a></div>
                <div className="col text-center"><a href="tel:9496986566"><img src="https://img.icons8.com/cute-clipart/64/000000/phone.png" alt="phone"/></a></div>
            </div>
        </div>
    )
}
